// extracted by mini-css-extract-plugin
export var button = "_nn-2";
export var card = "_nn-0";
export var closeButtonContainer = "_nn-3";
export var iconContainer = "_nn-1";